import { render, staticRenderFns } from "./FormExTypeLocale.vue?vue&type=template&id=025d49b6&scoped=true&"
import script from "./FormExTypeLocale.vue?vue&type=script&lang=js&"
export * from "./FormExTypeLocale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025d49b6",
  null
  
)

export default component.exports